// @flow

import type { ChatBubbleMessage } from '@chatchamp/chatchamp-types'

export type MessagesState = {
  messages: Array<ChatBubbleMessage<any>>,
  progressPercent: ?number,
  progressMessage: ?string,
  customerSupport: string,
  isShowingTypingIndicator: boolean,
  lastMessageReceived: ?Date,
  autoScroll: boolean,
  unreadMessagesCount: number,
  moreProductsClicked: boolean,
  clientSideMessageIds: Array<string>
}

export const state: MessagesState = {
  messages: [],
  progressPercent: null,
  progressMessage: null,
  customerSupport: '',
  isShowingTypingIndicator: false,
  lastMessageReceived: null,
  autoScroll: true,
  unreadMessagesCount: 0,
  moreProductsClicked: false,
  clientSideMessageIds: []
}
